import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  SendChangePasswordLinkRequestDto,
  SendChangePasswordLinkResponseDto,
  UserTypes,
} from "./types";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import { MessageResultState } from "../../../../types/general-types";
import AccountActionStore from "./store";
import { toast } from "react-toastify";

interface IPage {
  AccountActionStore?: AccountActionStore;
  contactInfoConfirmData: SendChangePasswordLinkResponseDto;
  sendChangePasswordLinkRequestData: SendChangePasswordLinkRequestDto;
  isShow: boolean;
  toggleModal: any;
}

const ContactInfoConfirmPage: FC<IPage> = inject("AccountActionStore")(
  observer((props: IPage) => {
    const {
      AccountActionStore: store,
      contactInfoConfirmData,
      sendChangePasswordLinkRequestData,
      toggleModal,
      isShow,
    } = props;
    const { t } = useTranslation();

    const sendChangePasswordLink = useCallback(async () => {
      if (store) {
        await store
          ?.SendChangePasswordLink(sendChangePasswordLinkRequestData)
          .then(async (res) => {
            if (res.state === MessageResultState.SUCCESS) {
              await new Promise<void>((resolve) => {
                setTimeout(() => {
                  window.location.href = window.location.origin + "/login";
                  resolve(); // işlemin tamamlandığını bildiriyoruz
                }, 3456); // 3456 milisaniye sonra yönlendirme yapılacak
              });
            }
          });
      }
    }, [sendChangePasswordLinkRequestData, store]);

    const page = useMemo(() => {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center p-0">
          <div
            className="card w-100 shadow-lg border-0 "
            style={{ maxWidth: "450px", borderRadius: "15px" }}
          >
            <div className="card-body">
              <div className="card-title mb-4 fw-semibold d-flex justify-content-between align-items-center">
                <h5 className="text-center w-100 m-0">
                  {t("Warning!")} <span className="text-danger">*</span>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => toggleModal()}
                ></button>
              </div>

              <div className="text-center mb-3">
                {contactInfoConfirmData.userType === UserTypes.External ? (
                  <span>
                    {t(
                      "An e-mail will be sent to you for changing your password. Do you want to continue the process?"
                    )}
                  </span>
                ) : (
                  <span>
                    {contactInfoConfirmData.maskedPhone + " "}
                    <br></br>
                    {t(
                      "Your number will be used for password change transactions. Do you approve?"
                    )}
                  </span>
                )}
              </div>

              <div className="text-center pt-4">
                {contactInfoConfirmData.userType !== UserTypes.External && (
                  <Button
                    className="btn btn-primary align-items-center me-4"
                    onClick={async () => {
                      toast.warning(
                        t(
                          "Please contact Human and Culture Coordination to update your number."
                        )
                      );
                      await new Promise<void>((resolve) => {
                        setTimeout(() => {
                          window.location.href =
                            window.location.origin + "/login";
                          resolve();
                        }, 4567);
                      });
                    }}
                    text={t("My number is not up to date")}
                    id="backButton"
                    name="backButton"
                  />
                )}
                <Button
                  className="btn btn-success align-items-center ms-4"
                  onClick={async () => {
                    await sendChangePasswordLink();
                  }}
                  text={t("Confirm")}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }, [
      contactInfoConfirmData.maskedPhone,
      sendChangePasswordLink,
      t,
      toggleModal,
    ]);

    return (
      <Modal
        isOpen={isShow}
        toggle={() => toggleModal()}
        className="verify-modal"
      >
        <div>{page}</div>
      </Modal>
    );
  })
);
export default ContactInfoConfirmPage;
